import PropTypes from "prop-types";
import { useContext, useState } from "react";
import { createUseStyles } from "react-jss";
import jssVariables from "../../jss_setup";
import { StyleTypeContext } from "../../umbilical_tools";
import { useSelector } from "react-redux";
import { RegistrationForm, SuccessModal } from "./components";

const styles = createUseStyles({
  Registration: (props) => ({
    position: "relative",
    width: "100vw",
    top: jssVariables.navbar_height,
    padding: jssVariables.normal_gap,
    paddingBottom: `calc(${jssVariables.navbar_height} * 2)`,
    ...(props?.customStyles?.Registration ?? {}),
  }),
  imgOverlay: (props) => ({
    display: "none",
    ...(props?.customStyles?.imgOverlay ?? {}),
  }),
  backgroundImg: (props) => ({
    position: "absolute",
    top: 0,
    left: 0,
    height: "100%",
    width: "100vw",
    objectFit: "cover",
    zIndex: -1,
    ...(props?.customStyles?.backgroundImg ?? {}),
  }),
  content: (props) => ({
    position: "relative",
    zIndex: 1,
    display: "grid",
    gridGap: jssVariables.double_gap,
    width: "100%",
    ...(props?.customStyles?.content ?? {}),
  }),
  info: (props) => ({
    background: "rgba(255, 255, 255, 0.3)",
    color: "black",
    backdropFilter: "blur(3.5px)",
    padding: jssVariables.double_gap,
    borderRadius: jssVariables.border_radius,
    display: "grid",
    gridGap: jssVariables.normal_gap,
    ...(props?.customStyles?.info ?? {}),
  }),
  infoHeader: (props) => ({
    fontWeight: "bold",
    fontSize: "large",
    ...(props?.customStyles?.infoHeader ?? {}),
  }),
  infoText: (props) => ({
    fontSize: "large",
    ...(props?.customStyles?.infoText ?? {}),
  }),
  formContr: (props) => ({
    background: "rgba(255, 255, 255, 0.6)",
    color: "black",
    backdropFilter: "blur(15.5px)",
    padding: jssVariables.double_gap,
    borderRadius: jssVariables.border_radius,
    ...(props?.customStyles?.formContr ?? {}),
  }),
  [`@media ${jssVariables.media.smallscreen}`]: {
    Registration: (props) => ({
      position: "relative",
      width: "100vw",
      top: jssVariables.navbar_height,
      paddingLeft: 0,
      paddingRight: 0,
      ...(props?.customStyles?.Registration?.smallscreen ?? {}),
    }),
    content: (props) => ({
      gridTemplateColumns: "max-content 1fr",
      gridGap: jssVariables.normal_gap,
      width: "70rem",
      left: "50%",
      transform: "translateX(-50%)",
      ...(props?.customStyles?.content?.smallscreen ?? {}),
    }),
    info: (props) => ({
      width: "20rem",
      height: "max-content",
      alignContent: "start",
      ...(props?.customStyles?.info?.smallscreen ?? {}),
    }),
    formContr: (props) => ({
      padding: jssVariables.double_gap,
      paddingTop: `calc(${jssVariables.normal_gap} * 1.5)`,
      ...(props?.customStyles?.formContr?.smallscreen ?? {}),
    }),
  },
  [`@media ${jssVariables.media.bigscreen}`]: {
    content: (props) => ({
      top: "50%",
      transform: "translate(-50%, -45%)",
      ...(props?.customStyles?.content?.smallscreen ?? {}),
    }),
  },
});
function Registration({ path, theme }) {
  const [showModal, setShowModal] = useState(false);

  const { type, brand, cStyler } = useContext(StyleTypeContext);
  const classes = styles({
    customStyles: cStyler({ type, brand, objName: "registration" }),
  });

  const list_page = useSelector((state) =>
    state.WebsiteMetadata.metadata.list_pages.find(
      (page) => page.path === path && page.theme === theme
    )
  );

  return (
    <div className={classes.Registration}>
      <img
        className={classes.backgroundImg}
        alt=""
        src={list_page?.images?.[0]?.photo_xl_url ?? ""}
      />
      {showModal && <SuccessModal />}
      <div className={classes.imgOverlay} />
      <div className={classes.content}>
        <div className={classes.info}>
          <div className={classes.infoHeader}>{list_page?.title ?? ""}</div>
          <div
            className={classes.infoText}
            dangerouslySetInnerHTML={{ __html: list_page?.description ?? "" }}
          />
        </div>
        <div className={classes.formContr}>
          <RegistrationForm setShowModal={setShowModal} />
        </div>
      </div>
    </div>
  );
}
Registration.defaultProps = {};
Registration.propTypes = {
  path: PropTypes.string.isRequired,
  theme: PropTypes.string.isRequired,
};
export default Registration;
